import React, { FunctionComponent } from 'react';
import { Button, Typography } from '@material-ui/core';
import buttonViewDetailsStyles from './ButtonViewDetailsStyles';
import clsx from 'clsx';
import Translation from '../translation/Translation';

interface IViewDetailsButton {
  onClick: () => void;
  position?: 'top' | 'bottom';
  captionId?: string;
}

const ButtonViewDetails: FunctionComponent<IViewDetailsButton> = ({
  onClick,
  position = 'top',
  captionId = 'spc.configuratorSummary.sticky.button.viewDetails',
}) => {
  const styles = buttonViewDetailsStyles();

  return (
    <Button
      className={clsx(styles.button, position === 'top' ? styles.positionTop : styles.positionBottom)}
      color="primary"
      variant="contained"
      onClick={onClick}
      data-test="button:sticky:view-details"
    >
      <Typography variant="helpingText">
        <Translation id={captionId} />
      </Typography>
    </Button>
  );
};

export default ButtonViewDetails;
